module.exports = __webpack_public_path__ + "static/media/img-social1.4fc4cd98.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/img-social1.png
// module id = 316
// module chunks = 0